import { lazy } from '../../shared/deployment';

// Core
export const PaginationWrapper = lazy(() => import('./PaginationWrapper'));
export const OfflinePageRenderer = lazy(() => import('./OfflinePageRenderer'));
export const Fetcher = lazy(() => import('./Fetcher'));

// Core
export { default as RenderCoreComponents } from './RenderCoreComponents';
export { default as DynamicDataLooper } from './DynamicDataLooper';
export { default as DynamicContentLooper } from './DynamicContentLooper';
export { default as ApiRequestComponent } from './ApiRequestComponent';
export { default as AppTop } from './AppTop';
export { default as AppFooter } from './AppFooter';
export { default as CookieBanner } from './CookieBanner';
